import { css } from "@emotion/react";

export const chevron = css`
  margin-left: 0.375rem;
`;

export const link = css`
  text-align: center;
`;

export const header = css`
  display: flex;
  align-items: center;
  margin: 8px 0;
`;

export const ingredient = css`
  flex: auto;
  display: flex;
`;

export const products = css`
  flex: 0 0 44px;
  margin: 0;
  display: flex;
`;

export const quantity = css`
  flex: 0 0 116px;
  margin-left: 1rem;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;
